import { render, staticRenderFns } from "./Playlists-details.vue?vue&type=template&id=e4b7c5c0&scoped=true&"
import script from "./Playlists-details.vue?vue&type=script&lang=js&"
export * from "./Playlists-details.vue?vue&type=script&lang=js&"
import style0 from "./Playlists-details.vue?vue&type=style&index=0&id=e4b7c5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b7c5c0",
  null
  
)

export default component.exports